export const BLANK_PAGE = null
export const DEFAULT_THEME = 'generic'
export const ENTRY = 'entry'
export const ENTRY_ID_PARAM_ERROR = 'No contentful entry ID supplied in url.'
export const ENVIRONMENT = 'environment'
export const FETCH_PRESENTATION_ERROR =
  'An error occurred retrieving the presentation from the Contentful API.'
export const FETCH_PRESENTATION_ERROR_UNPUBLISHED =
  FETCH_PRESENTATION_ERROR + ' Did you forget to publish the presentation?'
export const FORMAT = 'format'
export const INCLUDE = 'include'
export const CACHE = 'cache'
export const LOAD_PRESENTATION_ERROR = 'Unable to load presentation.'
export const MOCK_DATA = 'mockData'
export const PREVIEW = 'preview'
export const PREVIEW_PARAM_ERROR =
  'No preview param or invalid preview param supplied in url.'
export const SUCCESS = 200
export const THEME = 'theme'
export const TOKEN = 'token'
export const LOCALE = 'locale'
export const MODE = 'mode'
export const HS_THEME = 'gradehs'
export const CONTENT_REVIEW = 'contentReview'

// curriculum-service query params
export const USE_CURRICULUM_SERVICE = 'useCurriculumService'
export const SITE_ID = 'siteId'
export const CONTENT_GROUP_CODE = 'contentGroupCode'
export const RESOLUTION_MODE = 'resolutionMode'
export const DRAFT_MODE = 'draftMode'

// curriculum-service resolution modes
export const RESOLUTION_MODE_SINGLE_SITE = 'singleSite'
export const RESOLUTION_MODE_MULTI_SITE = 'multiSite'

export const CURRICULUM_SERVICE_NO_JWT_ERROR =
  'curriculum-service was requested but no JWT is available to authenticate the request.'
export const CURRICULUM_SERVICE_FETCH_ERROR =
  'An error occurred retrieving page content from the curriculum service.'

// Export all constants as an object for backward compatibility
export const AppWrapperConstants = {
  BLANK_PAGE,
  CACHE,
  CONTENT_REVIEW,
  DEFAULT_THEME,
  ENTRY,
  ENTRY_ID_PARAM_ERROR,
  ENVIRONMENT,
  FETCH_PRESENTATION_ERROR,
  FETCH_PRESENTATION_ERROR_UNPUBLISHED,
  FORMAT,
  INCLUDE,
  LOAD_PRESENTATION_ERROR,
  LOCALE,
  MODE,
  MOCK_DATA,
  PREVIEW,
  PREVIEW_PARAM_ERROR,
  SUCCESS,
  THEME,
  TOKEN,
  HS_THEME,
  USE_CURRICULUM_SERVICE,
  SITE_ID,
  CONTENT_GROUP_CODE,
  RESOLUTION_MODE,
  DRAFT_MODE,
  RESOLUTION_MODE_SINGLE_SITE,
  RESOLUTION_MODE_MULTI_SITE,
  CURRICULUM_SERVICE_NO_JWT_ERROR,
  CURRICULUM_SERVICE_FETCH_ERROR,
}
